import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  isTicketGadget: any;
  isUserLogged: boolean;

  constructor() {
    this.isTicketGadget = true;
    this.isTicketGadget = false;
  }

  ngOnInit() {
    if (localStorage.getItem('user')) {
      this.isUserLogged = true;
    }
  }

}
